var c=0,n=function(n){return void 0===n&&(n="id"),c+=1,"".concat(n,"-").concat(c)};export{n as creteNewId};
